import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import adsServices from "../../services/ads";
import { Navigate } from "react-router-dom";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DImage from "../../components/DImage";
import DButton from "../../components/DButton";
import { useDisclosure } from "@chakra-ui/react";
import DModal from "../../components/DModal";
import { toast } from "react-hot-toast";

const columns = [
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "الصورة",
        accessor: "img",
    },
    {
        Header: "التحكم",
        accessor: "actions",
    },
];
const Index = ({ title }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [currentId, setCurrentId] = useState();
    const queryClient = useQueryClient();
    const [currentPage, setCurrentPage] = useState(0);
    const { data, isLoading, error } = useQuery("getAllAds", () =>
        adsServices.getAllAds(currentPage + 1)
    );
    const deleteAds = () => {
        onClose();
        adsServices
            .deleteAds(currentId)
            .then(res => {
                toast.success("تم الحذف بنجاح");
                queryClient.refetchQueries(["getAllAds"]);
            })
            .catch(err => {
                if (err?.response?.status === 404) {
                    toast.error("الاعلان غير موجود");
                } else {
                    toast.error("حصل خطأ ما");
                }
            });
    };
    const formattedData = data => {
        if (data?.length > 0) {
            return data.map((d, index) => ({
                id: index,
                img: (
                    <div className="relative max-w-[150px] h-[150px] mx-auto">
                        <DImage
                            className={"h-full object-cover w-full"}
                            src={d}
                            alt={d}
                            load={true}
                        />
                    </div>
                ),
                actions: (
                    <DButton
                        bgColor="danger"
                        className={
                            "text-white min-w-[100px] rounded-[50px_!important]"
                        }
                        onClick={() => {
                            onOpen();
                            setCurrentId(d.slice(d.lastIndexOf("/") + 1));
                        }}
                    >
                        حذف
                    </DButton>
                ),
            }));
        }
        return [];
    };
    if (error) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <DModal
                isOpen={isOpen}
                onClose={onClose}
                modelType="delete"
                clickHandler={deleteAds}
                bodyText="هل تريد حذف هذا الإعلان"
            />
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <Table head={columns} body={formattedData(data.data)} />
                )}
            </DCard>
        </div>
    );
};

export default Index;
